// extracted by mini-css-extract-plugin
export default {"container":"ProfileQuestionsFinishedScreen_container__XoTzv","image":"ProfileQuestionsFinishedScreen_image__QCv69","textDiv":"ProfileQuestionsFinishedScreen_textDiv__si3uA"};